import React from 'react';
import { Play } from 'lucide-react';
import GameArtwork from '../../components/GameArtwork';
import { HOOKS, hook } from '../../lib/domHooks';

/**
 * Merit şemasının oyun kartı: görselin altında oyun adı ve sağlayıcı.
 *
 * Ana sayfadaki bütün şeritler — "Size Özel Seçtiklerimiz" dâhil — bu tek
 * kartı çizer. Vitrin şeridinin bir süre kendi açık zeminli varyantı vardı
 * ("Hemen Oyna" bantlı krem kart); şemanın koyu zemininde yamalı durduğu için
 * kaldırıldı. Renkler tema değişkenlerinden (`--pusu-*`) gelir, buraya sabit
 * renk yazmayın.
 */
const MeritGameCard = ({ game, onPlay }) => {
  const play = () => onPlay?.(game);

  return (
    <div {...hook(HOOKS.GAME_CARD)} className="merit-card" onClick={play} role="button" tabIndex={0}
         onKeyDown={(event) => { if (event.key === 'Enter') play(); }}>
      <div className="merit-card-art">
        {game.new && (
          <span className="merit-card-badge" style={{ background: 'var(--pusu-gold)', color: 'var(--pusu-on-accent)' }}>
            YENİ
          </span>
        )}
        {!game.new && game.hot && (
          <span className="merit-card-badge" style={{ background: '#c62e31' }}>POPÜLER</span>
        )}
        <GameArtwork src={game.img || game.image} alt={game.name} />
        <span className="merit-card-play">
          <span className="merit-btn merit-btn-accent" style={{ borderRadius: 999, height: 44, width: 44, padding: 0 }}>
            <Play size={18} fill="var(--pusu-on-accent)" />
          </span>
        </span>
      </div>
      <div className="merit-card-name">{game.name}</div>
      <div className="merit-card-provider">{game.provider}</div>
    </div>
  );
};

export default MeritGameCard;
